import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CheckIcon from 'components/material-symbol/icons/Check'
import { useStyles } from './styles'

/**
 * Numbered steps. Steps before `currentStep` show a check, the current step is
 * navy, and later steps are neutral. `currentStep` 0 leaves every step neutral
 * (the checkout, before anything has happened).
 */
const StepsList = ({ steps, currentStep = 0, 'aria-label': ariaLabel }) => {
  const classes = useStyles()

  return (
    <ol className={classes.steps} aria-label={ariaLabel}>
      {steps.map(({ title, caption }, index) => {
        const number = index + 1
        const isDone = number < currentStep
        const isActive = number === currentStep
        return (
          <li
            key={title}
            className={classes.step}
            aria-current={isActive ? 'step' : undefined}
          >
            <Box
              className={clsx(
                classes.stepNumber,
                isActive && classes.stepNumberActive,
                isDone && classes.stepNumberDone,
              )}
              aria-hidden="true"
            >
              {isDone ? <CheckIcon fontSize="small" /> : number}
            </Box>
            <Box>
              <Typography className={classes.stepTitle}>{title}</Typography>
              {caption ? (
                <Typography className={classes.stepCaption}>
                  {caption}
                </Typography>
              ) : null}
            </Box>
          </li>
        )
      })}
    </ol>
  )
}

StepsList.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      caption: PropTypes.string,
    }),
  ).isRequired,
  currentStep: PropTypes.number,
  'aria-label': PropTypes.string,
}

export default StepsList
